/**
* @Description: 消息事件状态机
* @Autho: 方证
* @Date: 2019/12/10
*/
import {observable, action, computed, useStrict} from "mobx";
import config from 'config/Config';
import Serv from './HeaderBarServ';
import Utils from 'utils';
import Cookie from 'js-cookie';
import {message} from 'antd';
const CDN_BASE = "assets";
import {  isArray, toArray, includes, map, get } from 'lodash';
// useStrict(true);
class HeaderBarMod{
  @observable
  form = ''

  @observable
  messageCount = 0

  @action
  updateStore(payload) {
    for(let i in payload){
      this[i] = payload[i]
    }
  }
  logout = async (payload) => {
    let params = payload;
    return await Serv.logout(params);
  }

  @action getMessageCount = async payload => {
    let params = payload;
    let res = await Serv.getMessageCount(params);
    if (res && res.resultCode + '' === '0') {
      this.updateStore({messageCount: get(res, 'data.total', 0)})
    }else if(res.resultMsg){
      message.warn(res.resultMsg)
    }
  };
}

// ES6单例写法
export default new HeaderBarMod


// WEBPACK FOOTER //
// ./src/widget/HeaderBar/HeaderBarMod.js